/* Shop status line — browser-side recompute of snippets/custom-shop-status.liquid.
   Pages are cached for an hour or more, so the Liquid-rendered line can be
   stale around midnight and at opening/closing time; this recomputes the same
   logic in the shop's time zone from the JSON blob each instance carries, swaps
   the text, and repeats every minute while the page is open. Same resolution
   rules as the snippet: exception → narrowest period → main; '~' = closed. */
(function () {
  var WD = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function nowIn(tz) {
    var parts;
    try {
      parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hour12: false
      }).formatToParts(new Date());
    } catch (e) {
      return null;
    }
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    var hour = o.hour === '24' ? 0 : parseInt(o.hour, 10);
    return { date: o.year + '-' + o.month + '-' + o.day, min: hour * 60 + parseInt(o.minute, 10) };
  }

  function utcDate(s) { return new Date(s + 'T00:00:00Z'); }
  function addDays(s, n) {
    var d = utcDate(s);
    d.setUTCDate(d.getUTCDate() + n);
    return d.toISOString().slice(0, 10);
  }
  function weekday(s) { return WD[utcDate(s).getUTCDay()]; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function fmtDate(s, fmt) {
    var d = utcDate(s);
    return fmt
      .replace('%-d', d.getUTCDate()).replace('%-m', d.getUTCMonth() + 1)
      .replace('%d', pad(d.getUTCDate())).replace('%m', pad(d.getUTCMonth() + 1))
      .replace('%b', MONTHS[d.getUTCMonth()]).replace('%B', MONTHS[d.getUTCMonth()]);
  }
  function minutes(t) {
    var p = t.split(':');
    return parseInt(p[0], 10) * 60 + (p.length > 1 ? parseInt(p[1], 10) : 0);
  }
  function clean(h) { return (h || '').replace(/\s+/g, '') || '~'; }

  function regular(data, day) {
    var wd = weekday(day), best = null, bestSpan = Infinity;
    data.periods.forEach(function (p) {
      if (day < p.from || day > p.to) return;
      var span = utcDate(p.to) - utcDate(p.from);
      if (span < bestSpan) { best = p; bestSpan = span; }
    });
    return clean(best ? best.days[wd] : data.main[wd]);
  }
  function exceptionIndex(data, day) {
    for (var i = 0; i < data.exceptions.length; i++) {
      var x = data.exceptions[i];
      if (day >= x.from && day <= x.to) return i;
    }
    return -1;
  }
  function fill(s, vars) {
    return s.replace(/__([A-Z]+)__/g, function (m, k) { return vars[k] === undefined ? '' : vars[k]; });
  }

  function compute(data, now) {
    var eff = [], reg = [], exc = [], wds = [], days = [];
    for (var i = 0; i <= data.lookahead; i++) {
      var day = addDays(now.date, i);
      var r = regular(data, day);
      var xi = exceptionIndex(data, day);
      days.push(day);
      wds.push(weekday(day));
      reg.push(r);
      exc.push(xi);
      eff.push(xi < 0 ? r : clean(data.exceptions[xi].hours));
    }
    var sep = data.minute_sep;
    var S = data.strings;
    var fmtTime = function (t) { return t.replace(':', sep); };
    var fmtHours = function (h) { return h.replace(/-/g, '–').replace(/,/g, ', ').replace(/:/g, sep); };
    var labelOf = function (x) {
      if (!x.label) return '';
      return ' (' + (data.lower_labels ? x.label.toLowerCase() : x.label) + ')';
    };
    var resumeAfter = function (i) {
      for (var j = i + 1; j <= data.lookahead; j++) {
        if (exc[j] < 0 && eff[j] !== '~') return S.weekdays[wds[j]];
      }
      return '';
    };

    var line = null;
    if (eff[0] !== '~') {
      var ranges = eff[0].split(',');
      for (var k = 0; k < ranges.length && !line; k++) {
        var ends = ranges[k].split('-');
        if (now.min < minutes(ends[0])) line = fill(S.opens_today, { TIME: fmtTime(ends[0]) });
        else if (now.min < minutes(ends[1])) line = fill(S.closes_today, { TIME: fmtTime(ends[1]) });
      }
    }
    if (!line) {
      for (var n = 1; n <= data.lookahead && !line; n++) {
        if (eff[n] === '~') continue;
        var t = eff[n].split(',')[0].split('-')[0];
        line = fill(n === 1 ? S.opens_tomorrow : S.closed_next, { TIME: fmtTime(t), DAY: S.weekdays[wds[n]], DATE: fmtDate(days[n], data.date_format) });
      }
    }
    if (!line) line = S.closed_no_next;
    if (exc[0] >= 0 && data.exceptions[exc[0]].label) line += labelOf(data.exceptions[exc[0]]);

    // Announcements: deviations inside their announce window, grouped by
    // week. Today is covered by the line (and, in the footer, its own notice).
    var notices = [];
    if (data.context === 'footer' && exc[0] >= 0) {
      var x0 = data.exceptions[exc[0]];
      if (eff[0] === '~' && reg[0] !== '~') {
        notices.push({ kind: 'closed', today: true, x: x0, text: fill(S.notice_today_closed, { LABEL: labelOf(x0), RESUME: resumeAfter(0) }) });
      } else if (eff[0] !== '~' && eff[0] !== reg[0]) {
        notices.push({ kind: 'special', today: true, x: x0, text: fill(S.notice_today, { LABEL: labelOf(x0), HOURS: fmtHours(eff[0]) }) });
      }
    }
    var todayIdx = (WD.indexOf(wds[0]) + 6) % 7; // mon = 0 … sun = 6
    var toSunday = 6 - todayIdx;
    var groups = { this: [], next: [], later: [] };
    var count = 0;
    var prev = exc[0];
    for (var m = 1; m <= data.lookahead && data.context !== 'hero'; m++) {
      var cur = exc[m];
      if (cur < 0 || cur === prev) { prev = cur; continue; }
      prev = cur;
      var x = data.exceptions[cur];
      if (data.skip && x.handle === data.skip) continue;
      if (m > (x.announce || 7)) continue;
      var kind = '';
      if (eff[m] === '~' && reg[m] !== '~') kind = 'closed';
      else if (eff[m] !== '~' && eff[m] !== reg[m]) kind = 'special';
      if (!kind) continue;
      var mEnd = m;
      while (mEnd + 1 <= data.lookahead && exc[mEnd + 1] === cur) mEnd++;
      var group = m <= toSunday ? 'this' : (m <= toSunday + 7 ? 'next' : 'later');
      var name = (x.label || '').trim();
      var vars = { LABEL: name ? name.charAt(0).toUpperCase() + name.slice(1) : '' };
      var suffix = name ? '' : '_plain';
      if (mEnd > m) {
        vars.DAY = S.weekdays_short[wds[m]];
        vars.DAYEND = S.weekdays_short[wds[mEnd]];
      } else {
        vars.DAY = S.weekdays[wds[m]];
      }
      vars.DATE = fmtDate(days[m], data.date_format) + (mEnd > m ? '\u2013' + fmtDate(days[mEnd], data.date_format) : '');
      var text;
      if (kind === 'closed') {
        text = fill(mEnd > m ? S['item_closed_range' + suffix] : S['item_closed' + suffix], vars);
        if (data.context === 'footer') {
          var resume = resumeAfter(mEnd);
          if (resume) text += fill(S.resume_suffix, { RESUME: resume });
        }
      } else {
        var eR = eff[m].split(','), rR = reg[m].split(',');
        if (reg[m] !== '~' && eR.length === 1 && rR.length === 1 && eR[0].split('-')[0] === rR[0].split('-')[0]) {
          vars.TIME = fmtTime(eR[0].split('-')[1]);
          text = fill(S['item_open_until' + suffix], vars);
        } else {
          vars.HOURS = fmtHours(eff[m]);
          text = fill(S['item_hours' + suffix], vars);
        }
      }
      groups[group].push({ kind: kind, x: x, text: text });
      count++;
    }
    ['this', 'next', 'later'].forEach(function (g) {
      if (!groups[g].length) return;
      notices.push({ kind: 'week', heading: S['week_' + g], items: groups[g] });
    });
    return { line: line, notices: notices };
  }

  function render(el, data) {
    var now = nowIn(data.tz);
    if (!now) return;
    var result = compute(data, now);
    var lineEl = el.querySelector('.shop-status__text');
    if (lineEl && lineEl.textContent !== result.line) lineEl.textContent = result.line;

    el.querySelectorAll('.shop-status__notice').forEach(function (n) { n.remove(); });
    el.classList.remove('shop-status--has-closed', 'shop-status--has-special');
    var anchor = el.querySelector('[data-shop-status-data]');
    var firstKind = '';
    var addExtras = function (parent, x) {
      if (data.context !== 'hero' && x.description) {
        var desc = document.createElement('span');
        desc.className = 'shop-status__notice-desc';
        desc.textContent = x.description;
        parent.appendChild(desc);
      }
      if (data.context !== 'hero' && x.link) {
        var a = document.createElement('a');
        a.className = 'shop-status__notice-link';
        a.href = x.link;
        a.textContent = x.link;
        parent.appendChild(a);
      }
    };
    result.notices.forEach(function (n) {
      var span = document.createElement('div');
      if (n.kind === 'week') {
        span.className = 'shop-status__notice shop-status__notice--week';
        var heading = document.createElement('span');
        heading.className = 'shop-status__notice-heading';
        heading.textContent = n.heading;
        span.appendChild(heading);
        var ul = document.createElement('ul');
        ul.className = 'shop-status__list';
        n.items.forEach(function (item) {
          var li = document.createElement('li');
          li.className = 'shop-status__item shop-status__item--' + item.kind;
          if (item.x.icon) {
            var img = document.createElement('img');
            img.className = 'shop-status__item-icon';
            img.src = item.x.icon;
            img.alt = '';
            img.width = 20;
            img.height = 20;
            li.appendChild(img);
          }
          var textEl = document.createElement('span');
          textEl.className = 'shop-status__item-text';
          textEl.textContent = item.text;
          li.appendChild(textEl);
          addExtras(li, item.x);
          ul.appendChild(li);
          if (!firstKind) firstKind = item.kind;
        });
        span.appendChild(ul);
      } else {
        span.className = 'shop-status__notice shop-status__notice--today shop-status__notice--' + n.kind;
        span.textContent = n.text;
        addExtras(span, n.x);
        if (!firstKind) firstKind = n.kind;
      }
      el.insertBefore(span, anchor);
    });
    if (firstKind) el.classList.add('shop-status--has-' + firstKind);
    measure(el, data);
  }

  /* Hero (desktop): set --hero-status-bottom on the hero element so the
     slide content pads its top and the vertically centred headline ends up
     as far below the status line as the last content row (start links) sits
     above the hero's bottom edge. Measured, not computed: the heading's
     leading and the box's spacing make a pure geometric offset look uneven,
     so the gap difference is fed back until the two match. */
  /* The hero text reveal moves the heading and rows up from 50px below (a
     translate, or a relative top on inline rows). Measuring mid-animation
     fed that offset into the padding, which then shifted again on each
     remeasure and made the reveal jerk; measure where the row comes to rest. */
  function restingRect(node) {
    var rect = node.getBoundingClientRect();
    var cs = getComputedStyle(node);
    var dy = 0;
    if (cs.transform && cs.transform !== 'none' && window.DOMMatrixReadOnly) {
      dy += new DOMMatrixReadOnly(cs.transform).m42;
    }
    if (cs.position === 'relative') dy += parseFloat(cs.top) || 0;
    return { top: rect.top - dy, bottom: rect.bottom - dy };
  }

  function measure(el, data) {
    if (data.context !== 'hero' || !el.parentElement) return;
    var hero = el.parentElement;
    if (!window.matchMedia('(min-width: 750px)').matches) {
      hero.classList.remove('custom-hero--has-status');
      hero.style.removeProperty('--hero-status-bottom');
      return;
    }
    hero.classList.add('custom-hero--has-status');
    var slide = hero.querySelector('.custom-hero__slide.is-active') || hero.querySelector('.custom-hero__slide');
    var box = slide && slide.querySelector('.banner__box');
    if (!box || !box.firstElementChild) {
      hero.style.setProperty('--hero-status-bottom', (el.offsetTop + el.offsetHeight) + 'px');
      return;
    }
    var heroRect = hero.getBoundingClientRect();
    var statusRect = el.getBoundingClientRect();
    var topRect = restingRect(box.firstElementChild);
    var bottomRect = restingRect(box.lastElementChild);
    var gapTop = topRect.top - statusRect.bottom;
    var gapBottom = heroRect.bottom - bottomRect.bottom;
    var current = parseFloat(hero.style.getPropertyValue('--hero-status-bottom')) || 0;
    var next = Math.max(0, Math.round(current + (gapBottom - gapTop)));
    if (Math.abs(next - current) >= 1) {
      hero.style.setProperty('--hero-status-bottom', next + 'px');
      if (!el.__remeasure) {
        el.__remeasure = true;
        requestAnimationFrame(function () { el.__remeasure = false; measure(el, data); });
      }
    }
  }

  function init() {
    var instances = [];
    document.querySelectorAll('[data-shop-status]').forEach(function (el) {
      var script = el.querySelector('[data-shop-status-data]');
      if (!script) return;
      var data;
      try { data = JSON.parse(script.textContent); } catch (e) { return; }
      instances.push({ el: el, data: data });
      render(el, data);
      if (data.context === 'hero') {
        var remeasure = function () { measure(el, data); };
        if (window.ResizeObserver) {
          var ro = new ResizeObserver(remeasure);
          ro.observe(el);
          ro.observe(el.parentElement);
        }
        window.addEventListener('resize', remeasure);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasure);
        window.addEventListener('load', remeasure);
        setTimeout(remeasure, 1500);
      }
    });
    if (instances.length) {
      setInterval(function () {
        instances.forEach(function (i) { render(i.el, i.data); });
      }, 60000);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
